import {
  CommonActions,
  CommonActionType,
  SetFitToPlayAction,
  SetLocaleAction,
} from '../actions/commonActions';
import { IpDataModel } from '@/models/ip-data.model';
import { RegionCheckResponse } from '@/models/region-check.model';
import { WrapperPlatform } from '@/models/enum/wrapper-platform.enum';
import { OntarioLocationCheckStatus } from '@/models/enum/ontario-location-check-status.enum';

export interface CommonState {
  locale: string;
  fitToPlay: boolean;
  ipData: IpDataModel;
  btag: string;
  platform: WrapperPlatform;
  ontarioCanPlay: boolean;
  ontarioLocationCheckStatus: OntarioLocationCheckStatus;
  ontarioLocationCheckError?: string;
  detectedRegion: RegionCheckResponse;
}

const initialState = {
  locale: '',
  fitToPlay: true,
  ipData: {
    country: '',
    city: '',
    region: '',
  },
  btag: '',
  platform: WrapperPlatform.None,
  ontarioCanPlay: true,
  ontarioLocationCheckStatus: OntarioLocationCheckStatus.Idle,
  ontarioLocationCheckError: undefined,
  detectedRegion: {
    countryCode: null,
    regionCode: null,
  },
};

const setLocale = (state: CommonState, action: SetLocaleAction): CommonState => ({
  ...state,
  locale: action.locale,
});

const setFitToPlay = (state: CommonState, action: SetFitToPlayAction): CommonState => ({
  ...state,
  fitToPlay: action.fitToPlay,
});

export const commonReducer = (state = initialState, action: CommonActions) => {
  switch (action.type) {
    case CommonActionType.SetLocale:
      return setLocale(state, action);
    case CommonActionType.SetFitToPlay:
      return setFitToPlay(state, action);
    case CommonActionType.SetIpData:
      return { ...state, ipData: action.data };
    case CommonActionType.SetBtag:
      return { ...state, btag: action.btag };
    case CommonActionType.SetWrapperPlatform:
      return { ...state, platform: action.platform };
    case CommonActionType.SetOntarioCanPlay:
      return { ...state, ontarioCanPlay: action.canPlay };
    case CommonActionType.SetOntarioLocationCheckStatus:
      return {
        ...state,
        ontarioLocationCheckStatus: action.status,
        ontarioLocationCheckError: action.error,
      };
    case CommonActionType.SetDetectedRegion:
      return { ...state, detectedRegion: action.data };
    default:
      return state;
  }
};
